import { Container } from "./styles";

import linkedin from "../../assets/linkedin.svg";
import githubIcon from "../../assets/github.svg";
import telegram from "../../assets/telegram.svg";
import instagramIcon from "../../assets/instagram.svg";

export function Footer() {
  return (
    <Container className="footer">
      <div className="footer-left">
        <span className="git-branch"> main*</span>
        <span className="tech-stack">TypeScript</span>
        <span className="version">v2.1.0</span>
      </div>

      <div className="footer-center">
        <p>Copyright © {new Date().getFullYear()} oybekdev.uz</p>
      </div>

      <div className="footer-right">
        <div className="social-media">
          <a
            href="https://github.com/oybekdevuz/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={githubIcon} alt="GitHub" />
          </a>
          <a
            href="https://www.linkedin.com/in/oybekberdiyev"
            target="_blank"
            rel="noreferrer"
          >
            <img src={linkedin} alt="Linkedin" />
          </a>
          <a href="https://t.me/oybekdevuz" target="_blank" rel="noreferrer">
            <img src={telegram} alt="Telegram" />
          </a>
          <a
            href="https://www.instagram.com/oybek.swe"
            target="_blank"
            rel="noreferrer"
          >
            <img src={instagramIcon} alt="Instagram" />
          </a>
        </div>
        <span className="uptime">Uptime: 99.9%</span>
      </div>
    </Container>
  );
}
